// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RoadMap_wrapper__NV3LS","item":"RoadMap_item__MvgJL","icon":"RoadMap_icon__josj4","roadmap-footer":"RoadMap_roadmap-footer__jwHaK"};